<template>
    <div>
        <b-card :border-variant="!disabled ? 'primary':'secondary'">
            <div class="d-flex align-items-center justify-content-between mb-1">
                <h5 class="mb-0">Acta de Traspaso</h5>
                <b-button v-if="!disabled && can('delete_gei_master_delivery_installation_client_ee')"
                    variant="outline-success"
                    :disabled="hasMatchingDocument"
                    @click="addRow"
                >
                    <feather-icon
                        icon="PlusIcon"
                        size="16"
                        variant="success"
                        class="cursor-pointer "

                    />
                </b-button>

            </div>
            <form-base-document
                :documents-state-data="documents_transfer_certificate"
                :documents-columns="columns"
                :documents-route="documents_by_route_transfer_certificate"
                :context="'transfer-certificate'"
                :is-disabled="disabled"
                :create-permission="can('create_gei_master_transfer_certificate')"
                :delete-permission="can('delete_gei_master_transfer_certificate')"
            />

        </b-card>
    </div>
</template>

<script>
import {BCard, BButton} from 'bootstrap-vue'
import {mapState} from "vuex"
import {createHelpers} from "vuex-map-fields"
import formBaseDocument
    from "@/views/gei/masters_installations/form/generalDataAndRisks/components/base/formBaseDocument"

const {mapFields} = createHelpers({
    getterType: 'masterInstallationDocuments/getField',
    mutationType: 'masterInstallationDocuments/updateField',
})

export default {
    name: "FormGeneralDocuments",
    components: {
        BButton,
        BCard,
        formBaseDocument
    },
    props: {
        disabled: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            columns: [
              //  {key: 'accredits', label: 'Acredita', sortable: false},
             //   {key: 'project_code_sva', label: 'P.Cod.SVA', sortable: false},
              //  {key: 'product_id', label: 'Producto', sortable: false},
             //   {key: 'sub_product_id', label: 'Subproducto', sortable: false},
                {key: 'options', label: 'Acciones', sortable: false},
                {key: 'transfer_date', label: 'Fecha Traspaso', sortable: false},
                {key: 'provider_id', label: 'Proveedor', sortable: false},
                {key: 'project_responsible_id', label: 'Gestor Responsable', sortable: false},
                //     {key: 'pending', label: 'Pendiente', sortable: false},
                {key: 'observations', label: 'Observaciones', sortable: false},
            ],

        }
    },
    computed: {
        ...mapState('masterInstallation', ['master_installation']),
        ...mapState('masterInstallationDocuments', []),
        ...mapFields({
            documents_transfer_certificate: 'documents_transfer_certificate',
            documents_by_route_transfer_certificate: 'documents_by_route_transfer_certificate',
        }),
        hasMatchingDocument() {
          return this.documents_transfer_certificate.some(doc => doc.empty_row === true)
        }
    },
    mounted() {
        this.context = 'transfer-certificate'
        this.getAllProviders()
        this.getAllOrderMaintenanceTypeId()
        this.getAllSubOrderMaintenanceTypeId()
    },
    methods: {
        can(permission) {
            return this.$store.getters.can(permission)
        },
        addRow() {
            const newRow = {
                empty_row: true,
                transfer_date: null,
                provider_id: null,
                project_responsible_id: null,
                route: this.master_installation.installation_code + '/ACTA_TRASPASO',
                observations: null,
                options: null,
                master_installation_id: this.master_installation.id,
            }

            this.documents_transfer_certificate.push(newRow)

            this.documents_transfer_certificate.editedRow = newRow

        },
        getAllProviders() {
            this.showLoading = true

            this.$store.dispatch('providers/getAllProviders')
            .then(response => {
                this.showLoading = false
            })
            .catch(error => {
                this.showLoading = false
            })
        },
        getAllOrderMaintenanceTypeId() {
          this.showLoading = true

          this.$store.dispatch('orderMaintences/getAllOrderMaintenanceTypeId')
              .then(response => {
                this.showLoading = false
              })
              .catch(error => {
                this.showLoading = false
              })
        },
      getAllSubOrderMaintenanceTypeId() {
          this.showLoading = true

          this.$store.dispatch('orderSubMaintences/getAllSubOrderMaintenanceTypeId')
              .then(response => {
                this.showLoading = false
              })
              .catch(error => {
                this.showLoading = false
              })
        },
    }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

[dir] .modal .modal-header .close {
    box-shadow: none;
    transform: unset;
    background: none;
}
.table-container {
    max-height: 400px; /* Ajuste a altura máxima desejada */
    overflow-y: auto;
}
</style>